import { useQuery } from '@apollo/client/react';

import GET_API_KEYS_FOR_ACCOUNT from '../gql/api_keys/getApiKeysForAccount.gql';
import { DEFAULT_LOOKUP_SIZE, getOldest } from '@/lib/oldest';

/** The account's default API key: its oldest. `null` once loaded means the account has none. */
export const useDefaultApiKey = (accountId: string | null | undefined) => {
  const { data, loading, error } = useQuery(GET_API_KEYS_FOR_ACCOUNT, {
    variables: { id: accountId ?? undefined, first: DEFAULT_LOOKUP_SIZE },
    skip: !accountId,
  });

  const apiKeys = data?.apiKeysForAccount?.edges.map(({ node }) => node) ?? [];

  return { defaultApiKey: getOldest(apiKeys), loading, error };
};
